export default __webpack_public_path__ + "static/media/1.39392d4d.webp";